import { axiosV2 } from "config/@axios";

export const FETCH_SINGLE_QUARANTINE =
  "singleQuarantineActions::fetchSingleQuarantine";
export const FETCH_SINGLE_QUARANTINE_SUCCESS =
  "singleQuarantineActions::fetchSingleQuarantineSuccess";
export const FETCH_SINGLE_QUARANTINE_FAILED =
  "singleQuarantineActions::fetchSingleQuarantineFailed";

export const fetchSingleQuarantine =
  (id, silent = false) =>
  dispatch => {
    dispatch({
      type: FETCH_SINGLE_QUARANTINE,
      payload: {
        id,
        silent
      }
    });

    return axiosV2
      .get(`quarantines/${id}`)
      .then(response => {
        dispatch({
          type: FETCH_SINGLE_QUARANTINE_SUCCESS,
          payload: {
            id,
            singleQuarantine: response.data
          }
        });
      })
      .catch(err => {
        dispatch({
          type: FETCH_SINGLE_QUARANTINE_FAILED,
          payload: {
            id,
            errorText: err.errorMessage
          }
        });
      });
  };
